import axios from 'axios';
import { urlUsers } from '../utils';

export const apiUser = axios.create({
    baseURL: `${urlUsers}`
});